import { format, parseISO } from 'date-fns'
export const AssignedColumns = [
  {
    field: 'created_datetime',
    headerName: 'Assigned On',
    width: 160,
    headerClassName: 'super-app-theme--header',
    valueGetter: (param) => `${format(parseISO(param.row.created_datetime + ''), 'yyyy-MM-dd')}`,
  },
  {
    field: 'case_number',
    headerName: 'TRF ID',
    width: 150,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'patient_first_name',
    headerName: 'Patient Name',
    headerClassName: 'super-app-theme--header',
    width: 200,
    valueGetter: (params) => `${params.row.patient_last_name || ''}, ${params.row.patient_first_name || ''}`,
  },
  {
    field: 'stat_flag',
    headerName: 'Priority',
    width: 120,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => {
      if (params.row.stat_flag) {
        return 'HIGH'
      } else return 'Standard'
    },
  },
  {
    field: 'created_by',
    headerName: 'Assign By',
    headerClassName: 'super-app-theme--header',
    width: 200,
  },
]

export const RecentlyReleasedColumns = [
  {
    field: 'case_number',
    headerName: 'TRF ID',
    headerClassName: 'super-app-theme--header',
    width: 130,
  },
  {
    field: 'patient_first_name',
    headerClassName: 'super-app-theme--header',
    headerName: 'Patient Name',
    width: 198,
    valueGetter: (params) => `${params.row.patient_last_name || ''}, ${params.row.patient_first_name || ''}`,
  },
  {
    field: 'outcome',
    headerName: 'Result',
    headerClassName: 'super-app-theme--header',
    width: 167,
  },
]

export const PendingColumns = [
  {
    field: 'created_datetime',
    headerName: 'Assigned On',
    headerClassName: 'super-app-theme--header',
    width: 160,
  },
  {
    field: 'case_number',
    headerName: 'TRF ID',
    headerClassName: 'super-app-theme--header',
    width: 180,
  },
  {
    field: 'patient_first_name',
    headerName: 'Patient Name',
    headerClassName: 'super-app-theme--header',
    width: 250,
    valueGetter: (params) => `${params.row.patient_last_name || ''}, ${params.row.patient_first_name || ''}`,
  },
  {
    field: 'stat_flag',
    headerName: 'Priority',
    headerClassName: 'super-app-theme--header',
    width: 170,
    valueGetter: (params) => {
      if (params.row.stat_flag) {
        return 'HIGH'
      } else return 'Standard'
    },
  },
  {
    field: 'priority',
    headerName: 'Date Sent',
    headerClassName: 'super-app-theme--header',
    width: 150,
  },
  {
    field: 'priority',
    headerName: 'Assigned to',
    headerClassName: 'super-app-theme--header',
    width: 150,
  },
  {
    field: 'procedure_code',
    headerName: 'Case Type',
    headerClassName: 'super-app-theme--header',
    width: 180,
  },
]

export const CompletedCasescolumns = [
  {
    field: 'updated_datetime',
    headerName: 'Time of Release',
    headerClassName: 'super-app-theme--header',
    width: 210,
    valueGetter: (param) => `${format(parseISO(param.row.updated_datetime + ''), 'yyyy-MM-dd HH:mm:ss')}`,
  },
  {
    field: 'case_number',
    headerName: 'TRF ID',
    headerClassName: 'super-app-theme--header',
    width: 140,
  },
  {
    field: 'patient_first_name',
    headerName: 'Patient Name',
    headerClassName: 'super-app-theme--header',
    width: 230,
    valueGetter: (params) => `${params.row.patient_last_name || ''}, ${params.row.patient_first_name || ''}`,
  },
  {
    field: 'outcome',
    headerName: 'Result',
    headerClassName: 'super-app-theme--header',
    width: 160,
  },
]
